import React from 'react';
import PropTypes from 'prop-types';

import { isPresent, valueOrPlaceholder } from 'helpers/string_helpers';
import CallContactLink from 'components/click_to_call/call_contact_link';
import CustomFieldValue, { isCustomFieldSlug } from './custom_field_value';
import SelectableRow from 'components/selectable_record_table/selectable_row';

const renderSaleRowCells = (currentColumns, currentUser, sale, edgeCrm) => {
  const propertyName = (
    <td key="property">
      <a href={edgeCrm ? sale.path : sale.propertyUrl}>
        <strong>{sale.displayName}</strong>
      </a>
    </td>
  );

  const additionalCells = currentColumns.map((column) => {
    if (isCustomFieldSlug(column)) {
      return <CustomFieldValue comp={sale} key={column} slug={column} />;
    } else if (column === 'ownerPhoneNumber') {
      return (
        <td className="hidden-xs hidden-sm" key={column}>
          <CallContactLink
            phone={sale.ownerPhoneNumber}
            phoneNormalized={sale.ownerPhoneNormalized}
            targetName={sale.ownerName}
            user={currentUser}
          />
        </td>
      );
    } else if (column === 'sellerName' && isPresent(sale[column])) {
      return renderContactLink(sale[column], sale.sellerUrl, column);
    } else if (column === 'ownerName' && isPresent(sale[column])) {
      return renderContactLink(sale[column], sale.ownerUrl, column);
    } else if (column === 'buyerName' && isPresent(sale[column])) {
      return renderContactLink(sale[column], sale.buyerUrl, column);
    } else {
      return (
        <td className="hidden-xs hidden-sm" key={column}>
          {valueOrPlaceholder(sale[column])}
        </td>
      );
    }
  });

  return [propertyName, ...additionalCells];
};

const renderContactLink = (contact, link, key) => (
  <td className="hidden-xs hidden-sm" key={key}>
    <a className="contact-link" href={link}>
      {contact}
    </a>
  </td>
);

const SaleRow = ({ currentColumns, currentUser, edgeCrm, sale, selected, onSelect }) => {
  const handleSelect = () => {
    onSelect && onSelect(sale);
  };

  return (
    <SelectableRow
      selected={selected}
      onChange={handleSelect}
    >
      {renderSaleRowCells(currentColumns, currentUser, sale, edgeCrm)}
    </SelectableRow>
  );
};

SaleRow.propTypes = {
  currentColumns: PropTypes.array.isRequired,
  currentUser: PropTypes.object.isRequired,
  edgeCrm: PropTypes.bool,
  sale: PropTypes.shape({
    buyerName: PropTypes.string,
    buyerUrl: PropTypes.string,
    displayName: PropTypes.string.isRequired,
    ownerName: PropTypes.string,
    ownerPhoneNormalized: PropTypes.string,
    ownerPhoneNumber: PropTypes.string,
    ownerUrl: PropTypes.string,
    path: PropTypes.string.isRequired,
    propertyUrl: PropTypes.string.isRequired,
    sellerName: PropTypes.string,
    sellerUrl: PropTypes.string
  }).isRequired,
  selected: PropTypes.bool,
  onSelect: PropTypes.func
};

export default SaleRow;
